import React from "react"
import { Hero, Image, Flex, ColorKeys } from "@capioweb/ui-components"
import { PropertyBoolean, QBankImage } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { LocalesContext } from "../../context"
import { imageBlockDataToImageProps } from "../../utils"

interface CapioNexusHeroBlockProps {
	heading: StringProperty
	ingress: StringProperty
	backgroundColor: ColorKeys
	imageDesktopBlock: QBankImage
	showCapioOnlineLink: PropertyBoolean
	capioOnlineLinkText: StringProperty
}

const CapioNexusHeroBlock: React.FC<CapioNexusHeroBlockProps> = (props) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)

	const srcSetSizes = [
		{ width: 1400, breakpoint: 1280 },
		{ width: 1600, breakpoint: 1920 },
		{ width: 2000, breakpoint: 2560 },
	]

	return (
		<Flex mb={2.5}>
			<Hero
				backgroundColor={props.backgroundColor}
				header={props.heading.value}
				img={
					<Image
						data-epi-edit="imageDesktopBlock"
						{...imageBlockDataToImageProps(
							props.imageDesktopBlock,
							true,
							true,
							srcSetSizes
						)}
					/>
				}
				description={props.ingress.value}
				locales={{
					showMore: translate(translationKeys.showMore) ?? "",
					showLess: translate(translationKeys.showLess) ?? "",
				}}
			/>
		</Flex>
	)
}

export { CapioNexusHeroBlock }
